import '../../../App.css';
import './EventOpenBettingData.css';
import { useState, useEffect } from 'react';
import { Input, Table, Select, Pagination, Popconfirm, Button, Modal } from 'antd';

import axios from 'axios';
import Appconfig from '../../../config/config'
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { TfiPencilAlt } from "react-icons/tfi";
import { useNavigate, useParams } from "react-router-dom";


function EventOpenBettingData() {
    const navigate = useNavigate();
    const params = useParams();
    const { event_id } = params;

    const userInfo = JSON.parse(localStorage.getItem('userdata'))
    const [openNews, setOpenNews] = useState(false)
    const [button, setButton] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [handlePassword, setHandlePassword] = useState('');
    const [deleteBetId, setDeleteBetId] = useState('');



    const [eventTypes, setEventTypes] = useState([])
    const [formData, setFormData] = useState({
        domain_name: "",
        site_code: "",
    });
    const [id, setId] = useState('')

    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState(data);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const handleOk = () => {
        if (handlePassword == "King@123") {
            deleteUserBet(deleteBetId);
        } else {
            NotificationManager.error(`Password Not Matched.`, '', 3000);

        }
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    let locale = {
        emptyText: 'No data!',
    };

    const handleSearch = (value, dataIndex) => {

        if (!value) {
            setFilteredData(data);
            return;
        }

        const filtered = data.filter(item => {
            return Array.isArray(dataIndex)
                ? dataIndex.some(key => item[key]?.toString().toLowerCase().includes(value.toLowerCase()))
                : item[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase());
        });

        // const filtered = data.length ? data.filter(item => item[dataIndex].toString().toLowerCase().includes(value.toLowerCase())) : [];
        setFilteredData(filtered);
        setCurrent(1); // Reset to the first page after a search
    };

    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1); // Reset to the first page after changing page size
    };

    const handleFirst = () => setCurrent(1);
    const handleLast = () => setCurrent(Math.ceil(filteredData?.length / pageSize));

    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedData = filteredData.slice(
        startIndex,
        endIndex
    );


    const handleSetFormData = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
    };


    function getOpenBetsByEvent() {
        var data = JSON.stringify({
            user_id: userInfo?._id,
            event_id: event_id
        });

        var config = {
            method: "post",
            url: `${Appconfig.apiUrl}betting/getOpenBetsByEvent`,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if (response.data.result) {
                    setFilteredData(response.data.resultData);
                    setData(response.data.resultData)
                }
                else {
                    console.log(response)
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    // const navigateToDetails = (event_id) => {
    //     navigate(`/betting/openBetsByEvent/${event_id}`);
    // };

    const deleteUserBet = (bet_id) => {
        const data = {
            _id: [String(bet_id)],
        };

        var config = {
            method: "post",
            url: `${Appconfig.apiUrl}betting/deleteBetting`,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };
        axios(config)
            .then(function (response) {

                if (response.status === 200 && response.data?.result === 1) {
                    NotificationManager.success(`Bet Delete Successfully`, '', 3000);
                    getOpenBetsByEvent();
                    setIsModalOpen(false);
                }
                else {
                    console.log(response)
                    NotificationManager.error(`Something Went Wrong`, '', 3000);

                }

            })
            .catch(function (error) {
                console.log(error);
            });

    }

    const confirm = (e) => {
        setIsModalOpen(true);
        setDeleteBetId(e);
    };
    const cancel = (e) => {
    };

    const formatDateTime = (dateValue) => {
        if (!dateValue) {
            return '-';
        }

        const date = new Date(dateValue);

        if (Number.isNaN(date.getTime())) {
            return dateValue;
        }

        const pad = (value) =>
            String(value).padStart(2, '0');

        return `${pad(date.getDate())}/${pad(
            date.getMonth() + 1
        )}/${date.getFullYear()} ${pad(
            date.getHours()
        )}:${pad(date.getMinutes())}`;
    };

    const columns = [
        {
            title: 'S.N.',
            key: 'serial_number',
            width: 85,
            render: (_, record, index) => (
                <span className="bet-data-serial">
                    {startIndex + index + 1}
                </span>
            ),
        },
        {
            title: 'User Name',
            dataIndex: 'user_name',
            key: 'user_name',
            width: 150,
            render: (value) => (
                <span className="bet-data-primary">
                    {value || '-'}
                </span>
            ),
        },
        {
            title: 'Place Name',
            dataIndex: 'place_name',
            key: 'place_name',
            width: 180,
            render: (value) => (
                <span className="bet-data-place">
                    {value || '-'}
                </span>
            ),
        },
        {
            title: 'Date & Time',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 180,
            render: (value) => (
                <span className="bet-data-date">
                    {formatDateTime(value)}
                </span>
            ),
        },
        {
            title: 'Round ID',
            key: 'betting_id',
            width: 150,
            render: (_, record) => (
                <span className="bet-data-round">
                    {record.betting_id ||
                        record._id ||
                        '-'}
                </span>
            ),
        },
        {
            title: 'Stake',
            dataIndex: 'stake',
            key: 'stake',
            width: 110,
            render: (value) => (
                <span className="bet-data-amount">
                    {Number(value || 0).toFixed(2)}
                </span>
            ),
        },
        {
            title: 'Price',
            dataIndex: 'price_val',
            key: 'price_val',
            width: 100,
            render: (value) => (
                <span className="bet-data-price">
                    {value ?? '-'}
                </span>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 110,
            render: (value) => (
                <span
                    className={`bet-data-status ${String(value).toLowerCase()
                        }`}
                >
                    {value || '-'}
                </span>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            width: 105,
            fixed: 'right',
            render: (_, record) => (
                <Popconfirm
                    title="Delete Bet"
                    description="Are you sure you want to delete this bet?"
                    onConfirm={() =>
                        confirm(
                            record.betting_id ||
                            record._id
                        )
                    }
                    onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button
                        danger
                        className="bet-data-delete"
                    >
                        Delete
                    </Button>
                </Popconfirm>
            ),
        },
    ];

    useEffect(() => {
        getOpenBetsByEvent();
    }, [])

    return (
        <>
            <NotificationContainer />

            <Modal
                title="Confirm Bet Deletion"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Delete Bet"
                cancelText="Cancel"
                okButtonProps={{
                    danger: true,
                }}
                className="bet-delete-modal"
            >
                <div className="bet-delete-modal-content">
                    <label>
                        Enter deletion password
                    </label>

                    <Input.Password
                        value={handlePassword}
                        placeholder="Enter password"
                        onChange={(event) =>
                            setHandlePassword(
                                event.target.value
                            )
                        }
                        onPressEnter={handleOk}
                    />
                </div>
            </Modal>

            <main className="bet-data-page">
                <section className="bet-data-card">
                    <div className="bet-data-heading">
                        <div className="bet-data-heading-content">
                            <span className="bet-data-heading-icon">
                                ⚙
                            </span>

                            <div>
                                <h1>Open Bets</h1>

                                <p>
                                    View and manage open bets
                                    for this event
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="bet-data-summary">
                        <div>
                            <span>Total Bets</span>

                            <strong>
                                {data.length}
                            </strong>
                        </div>

                        <div>
                            <span>Search Results</span>

                            <strong>
                                {filteredData.length}
                            </strong>
                        </div>

                        <div>
                            <span>Open</span>

                            <strong>
                                {
                                    data.filter(
                                        (bet) =>
                                            bet?.status ===
                                            'Open'
                                    ).length
                                }
                            </strong>
                        </div>
                    </div>

                    <div className="bet-data-toolbar">
                        <label className="bet-data-page-size">
                            <span>Show</span>

                            <Select
                                value={pageSize}
                                onChange={
                                    handlePageSizeChange
                                }
                                options={[
                                    {
                                        value: 10,
                                        label: '10',
                                    },
                                    {
                                        value: 25,
                                        label: '25',
                                    },
                                    {
                                        value: 50,
                                        label: '50',
                                    },
                                    {
                                        value: 100,
                                        label: '100',
                                    },
                                ]}
                            />

                            <span>entries</span>
                        </label>

                        <label className="bet-data-search">
                            <span>Search</span>

                            <Input
                                allowClear
                                placeholder="User, place, round or status"
                                onChange={(event) =>
                                    handleSearch(
                                        event.target.value,
                                        [
                                            'user_name',
                                            'place_name',
                                            'betting_id',
                                            'status',
                                        ]
                                    )
                                }
                            />
                        </label>
                    </div>

                    <div className="bet-data-table-wrapper">
                        <Table
                            rowKey={(record) =>
                                record?._id ||
                                record?.betting_id
                            }
                            locale={locale}
                            columns={columns}
                            className="bet-data-table"
                            dataSource={paginatedData}
                            pagination={false}
                            scroll={{
                                x: 1200,
                            }}
                        />
                    </div>

                    <div className="bet-data-pagination">
                        <div>
                            Showing{' '}
                            {filteredData.length
                                ? startIndex + 1
                                : 0}{' '}
                            to{' '}
                            {Math.min(
                                endIndex,
                                filteredData.length
                            )}{' '}
                            of {filteredData.length}{' '}
                            entries
                        </div>

                        <div className="bet-data-pagination-controls">
                            <button
                                type="button"
                                onClick={handleFirst}
                                disabled={current === 1}
                            >
                                First
                            </button>

                            <Pagination
                                current={current}
                                pageSize={pageSize}
                                total={
                                    filteredData.length
                                }
                                onChange={(page) =>
                                    setCurrent(page)
                                }
                                itemRender={(
                                    page,
                                    type,
                                    originalElement
                                ) => {
                                    if (type === 'prev') {
                                        return (
                                            <span>
                                                Previous
                                            </span>
                                        );
                                    }

                                    if (type === 'page') {
                                        return null;
                                    }

                                    if (type === 'next') {
                                        return (
                                            <span>
                                                Next
                                            </span>
                                        );
                                    }

                                    return originalElement;
                                }}
                                showSizeChanger={false}
                            />

                            <button
                                type="button"
                                onClick={handleLast}
                                disabled={
                                    current >=
                                    Math.max(
                                        1,
                                        Math.ceil(
                                            filteredData.length /
                                            pageSize
                                        )
                                    )
                                }
                            >
                                Last
                            </button>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}


export default EventOpenBettingData;
